export const RECEIVE_SETTINGS = 'APPLICATION:RECEIVE_SETTINGS';
export const OPEN_POPUP = 'APPLICATION:OPEN_POPUP';
export const CLOSE_POPUP = 'APPLICATION:CLOSE_POPUP';

export const UPDATE_MASTER_NICK_NAME = 'APPLICATION:UPDATE_MASTER_NICK_NAME';
export const UPDATE_MASTER_NICK_NAME_SUCCESS = 'APPLICATION:UPDATE_MASTER_NICK_NAME_SUCCESS';
export const UPDATE_MASTER_NICK_NAME_ERROR = 'APPLICATION:UPDATE_MASTER_NICK_NAME_ERROR';
export const RESET_MASTER_NICK_NAME_ERROR = 'APPLICATION:RESET_MASTER_NICK_NAME_ERROR';

export const ERROR_POPUP_KEY = 'APPLICATION:ERROR';
export const SUCCESS_POPUP_KEY = 'APPLICATION:SUCCESS';

export const POSTPAID_USER_TYPE = 'postpaid';
export const CONVERGENT_USER_TYPE = 'convergent';
export const FTTB_USER_TYPE = 'fttb';
export const SUB_CONVERGENT_USER_TYPE = 'subconvergent';

export const FETCH_SEB_DATA = 'APPLICATION:FETCH_SEB_DATA';

export const UPDATE_PERSONAL_DATA = 'APPLICATION:UPDATE_PERSONAL_DATA';
